import { API } from '../config/api';
import { DataService } from '../config/dataService/dataService';

class CustomViewsReportsService {
  static async getCustomViewsReports() {
    const { data } = await DataService.get(API.customViewsReports.root);
    return CustomViewsReportsService.transformCustomViewsReport(data)
  }

  static transformCustomViewsReport(data) {
    const viewsReports = {
      customViewsReports: data.customViewsReports
    };
    return viewsReports;
  }

  static async getAll({ page, search }) {
    const params = { page, search };
    const { data } = await DataService.get(`${API.customViewsReports.root}/all`, params);
    return {
      customViewsReports: data.customViewsReports,
      total: data.total,
      pageSize: data.pageSize,
    };
  }

  static async getById(id) {
    const { data } = await DataService.get(`${API.customViewsReports.root}/${id}`);
    return {
      customViewsReport: data.customViewsReport,
    };
  }

  static async create(customViewsReportData) {
    const { data } = await DataService.post(API.customViewsReports.root, customViewsReportData);
    return {
      customViewsReport: data.customViewsReport,
    };
  }

  static async update(id, customViewsReportData) {
    const { data } = await DataService.patch(`${API.customViewsReports.root}/${id}`, customViewsReportData);
    return {
      customViewsReport: data.customViewsReport,
    };
  }

  static async remove(id) {
    const { data } = await DataService.delete(`${API.customViewsReports.root}/${id}`);
    return {
      customViewsReport: data.customViewsReport,
    };
  }
}

export { CustomViewsReportsService };
